import request from '../index';

/** 和工程部有关的接口 **/

/** 
* ProjectProblemClosedLoop
* @params {string} data.abnormalProblemDesc 异常问题描述
* @params {string} data.closedLoopMeasures 闭环措施
* @params {string} data.examine 审核
* @params {string} data.head 负责人
* @params {number} data.id 
* @params {string} data.processes 工序
* @params {string} data.produce 项目
* @params {string} data.propose 建议
* @params {string} data.rootCauseAnalysis 根本原因分析
* @params {string} data.serialNumber 流水号
* @params {string} data.status 状态
* @params {string} data.temporaryMeasures 临时措施
*/

/** 
* 删除项目问题闭环工序
* @params {array} ids
*/
export const deleteProjectProblemClosedLoop = (data) => request.delete('/api-qc/deleteProjectProblemClosedLoop', { data });

/** 
* 获得项目问题闭环工序
* @params {string} params.examine 审核
* @params {string} params.project 项目
* @params {string} params.status 状态
*/
export const getProjectProblemClosedLoop = (params) => request.get('/api-qc/getProjectProblemClosedLoop', { params });

/** 
* 问题归纳（将质检问题归纳到闭环工序）
* @params {number} params.projectProblemClosedLoopId projectProblemClosedLoopId
* @params {string} params.serialNumber serialNumber
*/
export const problemInduction = (params) => request.get('/api-qc/problemInduction', { params });

/** 
* 新增or更新项目问题闭环工序
* @params {ProjectProblemClosedLoop} projectProblemClosedLoop
*/
export const saveProjectProblemClosedLoop = (data) => request.post('/api-qc/saveProjectProblemClosedLoop', data);

/** 
* 更新项目问题闭环工序状态
* @params {number} params.id id
* @params {string} params.status 状态
*/
export const updateProjectProblemClosedLoopState = (params) => request.get('/api-qc/updateProjectProblemClosedLoopState', { params });


/** 
* 新增or更新过程潜在失效模式及影响分析
* @params {Pfmea} pfmea
*/
export const savePfmea = (data) => request.post('/api-qc/savePfmea', data);


/** 
* 删除过程潜在失效模式及影响分析
* @params {array} ids
*/
export const deletePfmea = (data) => request.delete('/api-qc/deletePfmea', { data });

/** 
* 获得过程潜在失效模式及影响分析列表
* @params {number} params.lineNum 每页显示多少条
* @params {number} params.pageNum 页码
* @params {string} params.productionProcesses 工序
* @params {number} params.projectLifeCycleId 项目
*/
export const getPfmeaList = (params) => request.get('/api-qc/getPfmeaList', { params });

/** 
* 更新使用状态
* @params {GZSerial} gzSerial
*/
export const update = (data) => request.put('/api-qc/update', data);

/** 
* 设备随机机身号
* @params {string} params.batch 批次
* @params {string} params.code 设备编码
* @params {number} params.generationTimes 生成次数
* @params {string} params.letter A/B
* @params {string} params.type 设备类型
*/
export const randomGZSerial = (params) => request.get('/api-qc/randomGZSerial', { params });

/** 
* 获取广州设备机身号列表
* @params {string} params.batch 批次
* @params {boolean} params.isUsed 是否已使用
* @params {number} params.lineNum 每页显示多少条
* @params {number} params.pageNum 页码
* @params {string} params.serial 设备名称
* @params {string} params.type 设备类型
*/
export const getGZSerialList = (params) => request.get('/api-qc/getGZSerialList', { params });

/** 
* 删除广州设备机身号
* @params {array} ids
*/
export const deleteGZSerial = (data) => request.delete('/api-qc/deleteGZSerial', { data });
